export default {
  imuData: {},
  isLoadingImu: false,
  errorsData: {},
  isLoadingErrors: false,
  patientData: {},
  isLoadingPatient: false,
  error: null,
};
